'use client';

import React, { createContext, useContext, useState, useEffect } from 'react';
import { getPermissionMapping } from './permissionMapping';
import Cookies from "js-cookie";
import { getAccessTokenOrRedirect } from '../utils/auth';
import { REACT_APP_PERMISSION_URL, REACT_APP_PERMISSION_KEY, REACT_APP_PRODUCT_CODE } from '../env';

type AccessControl = {
  [key: string]: { [key: string]: { R: string } };
};

type PermissionContextType = {
  permissions: {
    success: boolean;
    access_controls: AccessControl;
  } | null;
  loading: boolean
};

const PermissionContext = createContext<PermissionContextType>({ permissions: null , loading: true});

export function PermissionProvider({ children }: { children: React.ReactNode }) {
  const [permissions, setPermissions] = useState<PermissionContextType['permissions']>(null);
  const [loading, setLoading] = useState<boolean>(true);;

  useEffect(() => {
    const fetchPermissions = async () => {
      setLoading(true);
      try {
        // Replace this with your actual API endpoint
        //const response = await fetch('/api/access');
       // const data = await response.json();
       // console.log("url",process.env.REACT_APP_PERMISSION_URL)
        const jwt = getAccessTokenOrRedirect(Cookies.get.bind(Cookies));
         const url = REACT_APP_PERMISSION_URL;
         const permissionKey = REACT_APP_PERMISSION_KEY;
         const product_code = REACT_APP_PRODUCT_CODE;
        if (!url || !permissionKey || !product_code) {
          console.error('Missing required environment variables');
          return; // Exit early if any required env var is missing
        }
        const response = await fetch(url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-API-KEY': permissionKey
          },
          body: JSON.stringify({
            "product_code": product_code,
            "token": jwt
          })
        });
        const data = await response.json();
        if (data.statusCode == '200') {
          setPermissions(data.body);
        } else {
          console.error('Error fetching permissions');
        }
      } catch (error) {
        console.error('Error fetching permissions:', error);
      }
      finally {
        setLoading(false); // End loading
      }
    };

    fetchPermissions();
  }, []);

  return (
    <PermissionContext.Provider value={{ permissions , loading}}>
      {children}
    </PermissionContext.Provider>
  );
}

export function usePermission(permissionKey: string): boolean| 'loading' {

  const { permissions, loading } = useContext(PermissionContext);
  if (loading) return 'loading';
  const mapping = getPermissionMapping(permissionKey);
  if (!permissions || !permissions.success || !mapping) return false;

  const controller = permissions.access_controls[mapping.controller];
  if (!controller) return false;

  return !!controller[mapping.function];
  //  return true;
}
